import { toast } from 'sonner';
import { getApiErrorMessage } from '@/lib/utils';
import { DeleteDialog } from '@/components/shared/delete-dialog';

interface CSIntentDeleteDialogProps {
  deletingId: string | null;
  onOpenChange: (open: boolean) => void;
  isDeleting: boolean;
  onDelete: (id: string) => Promise<void>;
  onDeleted: (id: string) => void;
}

export function CSIntentDeleteDialog({ deletingId, onOpenChange, isDeleting, onDelete, onDeleted }: CSIntentDeleteDialogProps) {
  async function handleDelete() {
    if (!deletingId) return;
    try {
      await onDelete(deletingId);
      toast.success('Intent deleted successfully');
      onDeleted(deletingId);
    } catch (err) {
      console.error('CSIntentDeleteDialog.handleDelete failed', { deletingId, error: err });
      toast.error(getApiErrorMessage(err, 'Failed to delete intent'));
    } finally {
      onOpenChange(false);
    }
  }

  return (
    <DeleteDialog
      open={!!deletingId}
      onOpenChange={onOpenChange}
      onConfirm={() => void handleDelete()}
      title='Delete intent?'
      description={`Are you sure you want to delete intent ${deletingId ?? ''}? This action cannot be undone.`}
      isLoading={isDeleting}
    />
  );
}
